import { booleanAttribute, Component, input, model } from '@angular/core';

import { BspkRadio } from '../radio';
import { BspkToggleOption } from '../toggle-option';

export type RadioOptionSize = 'small' | 'base' | 'large';

/**
 * A control that allows users to choose one or more items from a list or turn a feature on or off.
 *
 * @see BspkRadio
 * @see BspkRadioGroup
 */
@Component({
  selector: 'bspk-radio-option',
  imports: [BspkRadio, BspkToggleOption],
  templateUrl: './radio-option.component.html',
  styleUrl: './radio-option.component.scss',
  host: {
    '[attr.data-size]': 'size()',
  },
})
export class BspkRadioOption<TValue = string> {
  value = input.required<TValue>();
  name = input.required<string>();
  label = input.required<string>();
  checked = model(false);
  description = input<string>();
  invalid = input(false, { transform: booleanAttribute });
  disabled = input(false, { transform: booleanAttribute });
  size = input<RadioOptionSize>('base');
}
